import { useCallback } from "react";

export const useOkSpinPixel = () => {
  const pushEvent = useCallback(({ eventName, properties = {} }) => {
    if (typeof window !== "undefined" && window?._okTag) {
      console.debug("success to push okspin pixel");
      // window._okTag.push(eventName, properties);
      window._okTag.push({
        eid: eventName,
        data: {
          ...properties,
        },
      });
    }
  }, []);

  return {
    isHaveOkSpinPixel: !!process.env.REACT_APP_OKSPIN_PIXEL_ID,
    pushEvent,
  };
};
